import { forwardRef } from '@chakra-ui/system';
import * as React from 'react';
import { IStackProps, Stack } from './Stack';

export const HorizontalStack = forwardRef<IStackProps, 'div'>((props, ref) => (
  <Stack align="center" {...props} direction="row" ref={ref} />
));
